import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const CreateWashingMethodPageHeader = () => {
  const { t } = useTranslation()
  const handleBack = useBack()
  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />}></Button>
      <PageHeader ghost={false} title={t('components.pages.washingMethods.create.pageHeader.title')} />
    </Space>
  )
}

CreateWashingMethodPageHeader.displayName = 'CreateWashingMethodPageHeader'
export default CreateWashingMethodPageHeader
